export const appVersion = {
	devel: '0.2.21',
	prod: '0.2.21'
}
